export default __webpack_public_path__ + "5a2c12855b05df3a5c557c940ebae6cd.png";